import { connect } from 'react-redux';
import ProfileModalComponent from '../components/ProfileModalComponent';
import { setProfileModalState, logout } from '../actions/ProfileActions';
import { setStream } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state) => ({
    isLoggedIn: !!state.profile.jwt,
    isOpen: state.profile.isOpen,
    user: state.profile.user,
    submitting: state.profile.submitting,
    currentStream: state.aovivoBar.MediaPlayer.currentStream,
    firebasePopupOpen: state.profile.firebasePopupOpen,
});

const mapDispatchToProps = (dispatch) => ({
    setProfileModalState: (open) => {
        dispatch(setProfileModalState(open));
    },
    logout: () => {
        dispatch(logout());
    },
    setStream: (streamId) => {
        dispatch(setStream(streamId));
    },
});

const ProfileModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProfileModalComponent);

export default ProfileModalContainer;
